import request from '@/utils/request'

export function addContact(data) {
    return request({
        url: `/consultations`,
        method: 'post',
        data,
    })
}